import GridStackController from '~/components/gridstack/gridstack.controller';
import { BaseController } from '~/utils/base-controller';
import { HomeLayoutService as HomeLayoutServiceType } from '~/pages/home/home-layout.service';
import { Alert } from '~/scripts/services/modal/modal';

export default class HomeController extends BaseController {
	/** @type {import('angular').IScope} */
	$scope;

	/** @type {Record<string, *>} */
	dashboards;

	/** @type {GridStackController['options']} */
	gridOptions = {
		acceptWidgets: true,
		cellHeight:    4,
		margin:        0,
		sizeToContent: true,
		staticGrid:    true,
		styleInHead:   true,
	};

	/** @type {?import('gridstack').GridStack} */
	gridstack = null;

	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {HomeLayoutServiceType} [HomeLayoutService]
	 */
	constructor(
		$injector,
		$scope,
		$timeout,
		HomeLayoutService,
	) {
		super($injector);

		// $rootScope.showSearch = true;
		this.$rootScope.$on('$locationChangeStart', (event, next) => {
			const getUrl = window.location;
			const baseUrl = `${getUrl.protocol}//${getUrl.host}/`;

			this.$rootScope.showSearch = (/\/list/.test(next.toString()) || next === baseUrl);
		});

		this.$rootScope.$on('$viewContentLoaded', () => {
			this.$rootScope.showSearch = true;
		});

		this.$scope = $scope;
		this.$timeout = $timeout;

		this.dashboards = [];

		if (HomeLayoutService) {
			/** @type {HomeLayoutServiceType} */
			this.homeLayoutService = HomeLayoutService;
		}
	}

	/**
	 *
	 * @param {import('gridstack').GridStack} reference
	 */
	async onGridReady(reference) {
		this.gridstack = reference;

		this.gridstack.on('dropped',
			/**
			 *
			 * @param {Event} event
			 * @param {import('gridstack').GridStackNode} previousWidget
			 * @param {import('gridstack').GridStackNode} newWidget
			 */
			async (event, previousWidget, newWidget) => {
				const availableWidget = this.homeLayoutService.availableWidgets.find(w => w.id === newWidget.id);

				if (newWidget.el) {
					this.gridstack?.removeWidget(newWidget.el);
				}

				const items = this.homeLayoutService.gridstack.getGridItems();

				const ids = items.map(item => item.getAttribute('gs-id'));

				if (availableWidget && ids.includes(availableWidget.id)) {
					const alert = new Alert(this.$injector);
					await alert.open({
						title:  `Le widget "${availableWidget.title}" existe déjà.`,
						body:   'Impossible d\'ajouter plusieurs fois le meme widget',
						accept: {
							label: 'OK',
							type:  'primary',
						},
					});
					return;
				}

				this.$timeout(() => {
					if (availableWidget) {
						const widgetElt = this.homeLayoutService.createWidgetElement(availableWidget);

						let widgetOptions = {
							w: 6,
							// h: 14,
							x:        0,
							y:        0,
							id:       availableWidget?.id,
							noMove:   false,
							noResize: false,
						};

						if (availableWidget) {
							widgetOptions = {
								...widgetOptions,
								w: newWidget.w ?? 0,
								// h: newWidget.h,
								x: newWidget.x ?? 0,
								y: newWidget.y ?? 0,
							};
						}

						if (widgetElt) {
							this.gridstack?.addWidget(widgetElt, widgetOptions);
						}
					}
				});
			});

		await this.homeLayoutService.onGridReady(reference);
	}
}
